import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
	CdkDrag,
	CdkDragDrop,
	CdkDragPlaceholder,
	CdkDropList,
	moveItemInArray,
} from '@angular/cdk/drag-drop';
import { AlertComponent } from 'src/app/shared/modals/alert/alert.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { SuccessComponent } from 'src/app/shared/modals/success/success.component';
import { ProgramBuilderMainService } from '../../program-builder-main.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProgramItemDetailsComponent } from '../../modals/program-item-details/program-item-details.component';
import { NChoicesModalComponent } from 'src/app/shared/modals/nchoices-modal/nchoices-modal.component';
import { windowTime } from 'rxjs';
import { ImageModalComponent } from './image-modal/image-modal.component';
import { EditProgramTextComponent } from './edit-program-text/edit-program-text.component';
import { Router } from '@angular/router';
import { ProgramPageComponent } from 'src/app/modules/learning-center/components/program-page/program-page.component';
import { ValidationAlertComponent } from './validation-alert/validation-alert.component';
import { PostHogService } from 'src/app/shared/services/posthog.service';
@Component({
	selector: 'app-edit-program-new-builder',
	templateUrl: './edit-program-new-builder.component.html',
	styleUrls: ['./edit-program-new-builder.component.scss']
})
export class EditProgramNewBuilderComponent implements OnInit {
	programDataCopy: any;
	dataLastCopy: any;
	videosityCategories: any = [];
	checkChangesInterval: any;
	categories: any = [];
	subCategories: any = [];
	categoryIndex: any;
	@ViewChild('autoResizeTextarea') textareaRef!: ElementRef<HTMLTextAreaElement>;
	@ViewChild('descBoxRef') descBoxRef!: ElementRef<HTMLTextAreaElement>;
	isDescriptionEditable: boolean = false;
	isPrgNameEditable: boolean = false;
	isPrgTaglineEditable: boolean = false;
	descBoxHeight: number = 0;
	autoSaved: boolean = true;

	constructor(
		public dialog: MatDialog,
		private snackbar: MatSnackBar,
		private router: Router,
		private spinner: NgxSpinnerService,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private programBuilderMainService: ProgramBuilderMainService,
		public dialogRef: MatDialogRef<EditProgramNewBuilderComponent>,
		private postHogService: PostHogService
	) {
		this.getVideosityCategories();
		this.getCategories();
	}

	ngOnInit() {
		// console.log('data...', this.data);
		this.programDataCopy = structuredClone(this.data);

		if (this.programDataCopy.isUserEnrolled) {
			delete this.programDataCopy.isUserEnrolled;
		}

		if (this.programDataCopy.progress) {
			delete this.programDataCopy.progress;
		}

		this.dataLastCopy = structuredClone(this.programDataCopy);

		this.checkChangesInterval = setInterval(async () => {
			await this.checkChangesAndSave();
		}, 5000);
	}

	ngAfterViewInit(): void {
		setTimeout(() => {
			this.descBoxHeight = this.descBoxRef.nativeElement.clientHeight;
		});
	}

	dropSection(event: CdkDragDrop<string[]>) {
		moveItemInArray(this.programDataCopy.sections, event.previousIndex, event.currentIndex);
		this.dfsSnoReset();

		// Capture PostHog event when section sequence is updated
		const userEmail = localStorage.getItem('username');
		const role = localStorage.getItem('roleId');
		const movedSection = this.programDataCopy.sections[event.currentIndex];

		this.postHogService.capture('Update Seq Section', {
			'User email': userEmail,
			'device_type': 'Web',
			'role': role,
			'programname_section name': `${this.programDataCopy.name}_${movedSection.name}`
		});
	}

	dropUnit(event: CdkDragDrop<string[]>, sectionIndex: number) {
		moveItemInArray(this.programDataCopy.sections[sectionIndex].menu, event.previousIndex, event.currentIndex);
		this.dfsSnoReset();

		// Capture PostHog event when unit sequence is updated
		const userEmail = localStorage.getItem('username');
		const role = localStorage.getItem('roleId');
		const movedUnit = this.programDataCopy.sections[sectionIndex].menu[event.currentIndex];

		this.postHogService.capture('Update Seq Unit', {
			'User email': userEmail,
			'device_type': 'Web',
			'role': role,
			'program name_unit-name': `${this.programDataCopy.name}_${movedUnit.name}`
		});
	}

	/** Re-sets the dfs and sno of all the units and sections after dropping the item. */
	dfsSnoReset() {
		let i = 1;
		for (let j = 0; j < this.programDataCopy.sections.length; j += 1) {
			let section = this.programDataCopy.sections[j];
			section.sno = `${j + 1}`;

			if (section.menu) {
				for (let k = 0; k < section.menu.length; k += 1) {
					let unit = section.menu[k];
					unit.dfs = i;
					unit.sno = `${j + 1}.${k + 1}`;
					i += 1;
				}
			}
		}

		// console.log(this.programDataCopy.sections);
	}

	async closeEditProgramBuilder(action: string) {
		clearInterval(this.checkChangesInterval);

		if (action === 'cancel') {
			this.dialogRef.close();
		} else if (action === 'save') {
			// let isProgramDataValid = this.validateProgramFields();

			// if (isProgramDataValid) {
			await this.spinner.show("blockLoader");
			this.setMandatoryFieldsProgramData();

			const res: any = await this.programBuilderMainService.addPrograms(this.programDataCopy.id, this.programDataCopy);
			await this.spinner.hide("blockLoader");

			if (res && res.status === 'success') {
				this.dialogRef.close({
					status: 'success',
					action: 'save',
					data: this.programDataCopy
				});
			}
			// }
		}
	}

	setMandatoryFieldsProgramData() {
		this.programDataCopy.updatedAt = new Date();
		this.programDataCopy.programMenuCompleted = true;
		this.programDataCopy.publishedAt = new Date();
		this.programDataCopy.numberOfSections = (this.programDataCopy.sections && this.programDataCopy.sections.length) ? this.programDataCopy.sections.length : 0;
		for (let section of this.programDataCopy.sections) {
			section.type = "menu";
			section.numberOfUnits = section.menu ? section.menu.length : 0;
		}
	}

	validateProgramFields() {
		let isValid = true;
		let missingItems = [];

		if (!this.programDataCopy.description) {
			isValid = false;
			missingItems.push("Description");
		}

		if (!this.programDataCopy.category) {
			isValid = false;
			missingItems.push("Program Category");
		}

		if (!this.programDataCopy.subCategory) {
			isValid = false;
			missingItems.push("Program Subcategory");
		}

		if (!this.programDataCopy.difficultyLevel) {
			isValid = false;
			missingItems.push("Difficulty Level");
		}

		if (!this.programDataCopy.courseTime) {
			isValid = false;
			missingItems.push("Course Time");
		}

		if (this.programDataCopy.sections.length >= 1) {
			for (let i = 0; i < this.programDataCopy.sections.length; i++) {
				if (!this.programDataCopy.sections[i].name || !this.programDataCopy.sections[i].description) {
					// this.dialog.open(SuccessComponent, {
					// 	data: {
					// 		title: "Oops!",
					// 		subTitle: `Please fill all details of section ${i + 1}.`
					// 	},
					// });
					if (!this.programDataCopy.sections[i].name) {
						missingItems.push(`Section ${i + 1} name`);
					}
					if (!this.programDataCopy.sections[i].description) {
						missingItems.push(`Section ${i + 1} description`);
					}

					isValid = false;
				}
				if (this.programDataCopy.sections[i].menu && this.programDataCopy.sections[i].menu.length >= 1) {
					for (let j = 0; j < this.programDataCopy.sections[i].menu.length; j++) {
						let unitItem = this.programDataCopy.sections[i].menu[j];

						if (!unitItem.name || !unitItem.pts || !unitItem.dfs || !unitItem.type) {
							if (!unitItem.name) {
								missingItems.push(`Section ${i + 1} - Unit ${j + 1} name`);
							}
							if (!unitItem.pts) {
								missingItems.push(`Section ${i + 1} - Unit ${j + 1} pts`);
							}
							if (!unitItem.dfs) {
								missingItems.push(`Section ${i + 1} - Unit ${j + 1} dfs`);
							}
							if (!unitItem.type) {
								missingItems.push(`Section ${i + 1} - Unit ${j + 1} type`);
							}

							isValid = false;
						}

						if (unitItem.type === "video") {
							let topic = unitItem.metadata.topics[0];
							if (!topic.thumbnailSource || !topic.videoLocation) {
								if (!topic.thumbnailSource) {
									missingItems.push(`Section ${i + 1} - Unit ${j + 1} thumbnail`);
								}

								if (!topic.videoLocation) {
									missingItems.push(`Section ${i + 1} - Unit ${j + 1} video`);
								}
								isValid = false;
							}
						}

						if (unitItem.type === "quiz") {
							if (!unitItem.quizType || unitItem.quizType !== "ispring quiz") {
								const quizTopic = unitItem.metadata.topics?.find((topic: any) =>
									topic.interactions?.some((interaction: any) => interaction.question_group)
								);
								if (!quizTopic) {
									missingItems.push(`Section ${i + 1} - Unit ${j + 1} course and category`);
									isValid = false;
								}
							} else if (!unitItem.quizUrl) {
								missingItems.push(`Section ${i + 1} - Unit ${j + 1} iSpring quiz deployment`);
								isValid = false;
							}
						}

						if (unitItem.type === "download") {
							let document = unitItem.metadata.documents[0];
							if (!document.link || (!document.portraitImage && !document.landscapeImage)) {
								if (!document.link) {
									missingItems.push(`Section ${i + 1} - Unit ${j + 1} document`);
								}

								if (!document.portraitImage && !document.landscapeImage) {
									missingItems.push(`Section ${i + 1} - Unit ${j + 1} image`);
								}
								isValid = false;
							}
						}
					}
				} else {
					isValid = false;
					missingItems.push(`Section ${i + 1} - No units`);
				}
			}
		} else {
			isValid = false;
			missingItems.push("No section added");
		}

		return [
			isValid,
			missingItems
		];
	}

	deleteItem(type: string, sectionIndex: number, unitIndex?: number) {
		const alertDialogRef = this.dialog.open(AlertComponent, {
			data: {
				title: "Please confirm!",
				subTitle: `Are you sure you want to <strong>permanently delete</strong> this ${type}?`
			},
			panelClass: "custom-alert-class"
		});
		alertDialogRef.afterClosed().subscribe(async result => {
			if (result) {
				if (type === "program") {
					await this.spinner.show("blockLoader");
					await this.programBuilderMainService.deleteProgram(this.programDataCopy.id);
					await this.spinner.hide("blockLoader");
				} else if (type === "section") {
					// remove this section, lower down the index of all the following sections
					this.programDataCopy.sections.splice(sectionIndex, 1);
					this.dfsSnoReset();
				} else if (type === "unit") {
					this.programDataCopy.sections[sectionIndex].menu.splice(unitIndex, 1);
					this.dfsSnoReset();
				}

				this.snackbar.open(`${type.charAt(0).toUpperCase()}${type.slice(1)} deleted!`, "OK", {
					duration: 3000
				});

				if (type === "program") {
					this.dialogRef.close({
						status: 'success',
						action: 'delete',
					});
				}
			}
		});
	}

	programItemDetailsCrud(action: string, type: string, sectionIndex?: number, unitIndex?: number) {
		if (action === "add" && type === "") {
			const choicesModalRef = this.dialog.open(NChoicesModalComponent, {
				data: {
					question: "What do you wish to add here?",
					choices: [
						{
							choice: "section",
							text: "Section"
						},
						{
							choice: "unit",
							text: "Unit"
						}
					]
				},
			});

			choicesModalRef.afterClosed().subscribe(result => {
				if (result && result.choice) {
					type = result.choice.toLowerCase();
					this.openProgramItemDetailsModal(action, type, sectionIndex, unitIndex);
				}
			});
		} else {
			this.openProgramItemDetailsModal(action, type, sectionIndex, unitIndex);
		}
	}

	openProgramItemDetailsModal(action: string, type: string, sectionIndex?: any, unitIndex?: any) {
		let data: any = {
			action,
			type,
			programDetails: {
				id: this.programDataCopy.id,
				sectionIndex,
				unitIndex
			},
			videosityCategories: this.videosityCategories
		};

		if (action === "edit") {
			if (unitIndex || unitIndex === 0) {
				data.itemCopy = structuredClone(this.programDataCopy.sections[sectionIndex].menu[unitIndex]);
			} else {
				data.itemCopy = structuredClone(this.programDataCopy.sections[sectionIndex]);
			}
		}
		const alertDialogRef = this.dialog.open(ProgramItemDetailsComponent, {
			data,
			panelClass: 'program-item-details-modal'
		});
		alertDialogRef.afterClosed().subscribe(async result => {
			if (result && result.status === "success" && result.data) {
				let msg = "";
				if (action === "add") {
					if (type === "section") {
						this.programDataCopy.sections.splice(sectionIndex, 0, result.data);
					} else if (type === "unit") {
						this.programDataCopy.sections[sectionIndex].menu.splice(unitIndex, 0, result.data);
					}

					msg = `${type.charAt(0).toUpperCase()}${type.slice(1)} added.`;
					this.dfsSnoReset();
				} else if (action === "edit") {
					if (type === "section") {
						this.programDataCopy.sections[sectionIndex] = result.data;
					} else if (type === "unit") {
						this.programDataCopy.sections[sectionIndex].menu[unitIndex] = result.data;
					}

					msg = `${type.charAt(0).toUpperCase()}${type.slice(1)} details saved.`;
				}

				this.snackbar.open(msg, "OK", {
					duration: 3000
				});
			} else {
				// console.log(`${type} saving cancelled!`);
			}
		});
	}

	getVideosityCategories() {
		this.programBuilderMainService.getCategoriesApi().subscribe((data) => {
			this.videosityCategories = data.categories;
		});
	}

	getCategories() {
		// console.log('In organization')
		this.programBuilderMainService.getCategories().subscribe((data: any) => {
			this.categories = data;
			//   console.log(this.categories);
			this.categories.forEach(async (el: any, index: any) => {
				if (this.data) {
					if (el.id === this.data.category?.id) {
						this.categoryIndex = index;
						this.programDataCopy.category.name = el.name;
						this.programDataCopy.category.id = el.id;
						await this.getSubCategories(el.subCategories);
					}
				}
			});
		});
	}

	async getSubCategories(subCategories: any) {
		let visibleSubCat: any = [];
		await subCategories.forEach((subCat: any) => {
			if (subCat.visible) {
				visibleSubCat.push(subCat);
			}
			// console.log(visibleSubCat);
			this.subCategories = visibleSubCat;
		})
	}

	changeCategory(ev: any) {
		// console.log(ev);
		// console.log(this.jsonData.category);
		this.subCategories = [];
		this.autoSaved = false;
		this.categories.forEach(async (el: any, index: any) => {
			if (el.id === ev) {
				this.categoryIndex = index;
				this.programDataCopy.category.name = el.name;
				this.programDataCopy.category.id = el.id;
				await this.getSubCategories(el.subCategories);
			}
		})
	}

	changeSubCategory(ev: any) {
		// console.log(ev);
		this.autoSaved = false;
		this.categories[this.categoryIndex].subCategories.forEach((el: any) => {
			if (el.id === ev) {
				this.programDataCopy.subCategory.name = el.name;
				this.programDataCopy.subCategory.id = el.id;
			}
		})
	}

	async onFileChange(event: any, type: string) {
		const reader = new FileReader();

		if (event.target.files && event.target.files.length) {
			const [file] = event.target.files;

			if (file.size > 1048576) {
				this.snackbar.open("File size must not exceed 1 MB.", "OK", {
					duration: 3000
				});
				event.target.value = null;
				return;
			}

			reader.readAsDataURL(file);

			reader.onload = async () => {
				const base64Response = await fetch(reader.result as string);
				// console.log(base64Response.url)
				if (type === 'programImage') {
					this.programDataCopy.programImage = base64Response.url;
				} else if (type === 'landscapeImage') {
					this.programDataCopy.landscapeImage = base64Response.url;
				}
			};
		}
	}

	toggleEditDescription(fieldName: string, fieldText: string, limit?: number) {
		this.isDescriptionEditable = !this.isDescriptionEditable;
		// setTimeout(() => {
		// 	this.adjustTextareaHeight(this.textareaRef.nativeElement);
		// });

		const modal = this.dialog.open(EditProgramTextComponent, {
			data: {
				fieldName, fieldText, limit: limit || 0
			},
			panelClass: 'edit-program-text-modal',
			minWidth: '50%',
			hasBackdrop: false
		})

		modal.afterClosed().subscribe((res) => {

			this.isDescriptionEditable = !this.isDescriptionEditable;
			if (res) {
				this.programDataCopy.description = res;
			}
		})
	}

	adjustTextareaHeight(textarea: HTMLTextAreaElement): void {
		console.log('textarea', textarea);
		textarea.style.height = 'auto';  // Reset the height to auto
		textarea.style.height = `${textarea.scrollHeight}px`;  // Set height to the scrollHeight to match content
	}

	toggleEditPrgName(fieldName: string, fieldText: string, limit?: number) {
		this.isPrgNameEditable = !this.isPrgNameEditable;
		if (this.isPrgTaglineEditable) this.isPrgTaglineEditable = false;

		const modal = this.dialog.open(EditProgramTextComponent, {
			data: {
				fieldName, fieldText, limit: limit || 0
			},
			panelClass: 'edit-program-text-modal',
			minWidth: '50%',
			hasBackdrop: false
		})

		modal.afterClosed().subscribe((res) => {

			this.isPrgNameEditable = !this.isPrgNameEditable;
			if (res) {
				this.programDataCopy.name = res;
			}
		})
	}

	toggleEditTagline(fieldName: string, fieldText: string, limit?: number) {
		this.isPrgTaglineEditable = !this.isPrgTaglineEditable;
		if (this.isPrgNameEditable) this.isPrgNameEditable = false;

		const modal = this.dialog.open(EditProgramTextComponent, {
			data: {
				fieldName, fieldText, limit: limit || 0
			},
			panelClass: 'edit-program-text-modal',
			minWidth: '50%',
			hasBackdrop: false
		})

		modal.afterClosed().subscribe((res) => {

			this.isPrgTaglineEditable = !this.isPrgTaglineEditable;
			if (res) {
				this.programDataCopy.tagline = res;
			}
		})
	}

	removeLandscapeImage() {
		this.autoSaved = false;
		this.programDataCopy.landscapeImage = "";
	}

	removeSquareImage() {
		this.autoSaved = false;
		this.programDataCopy.programImage = "";
	}

	previewImage(url: string, imageType: string) {
		const modal = this.dialog.open(ImageModalComponent, {
			data: {
				url, imageType
			},
			panelClass: 'image-preview-modal'
		})
	}

	async checkChangesAndSave() {
		const currentCopyString = JSON.stringify(this.programDataCopy);
		const lastCopyString = JSON.stringify(this.dataLastCopy);

		if (currentCopyString !== lastCopyString) {
			// console.log("changes are detected!");
			// autosave changes
			this.programDataCopy.updatedAt = new Date();
			await this.programBuilderMainService.addPrograms(this.programDataCopy.id, this.programDataCopy);
			// console.log("autosave done");
			this.autoSaved = true;
			this.dataLastCopy = structuredClone(this.programDataCopy);
		} else {
			// console.log("no changes!");
		}
	}

	async routeToPreview() {
		await this.spinner.show("blockLoader");
		// this.setMandatoryFieldsProgramData();
		await this.programBuilderMainService.addPrograms(this.programDataCopy.id, this.programDataCopy);
		await this.spinner.hide("blockLoader");

		const dataToPass = {
			isPreview: true,
			programData: structuredClone(this.programDataCopy)
		};
		localStorage.setItem("previewState", JSON.stringify(dataToPass));
		this.dialogRef.close({});

		this.router.navigate(['programs']);

		// this.dialog.open(ProgramPageComponent, {
		// 	maxHeight: '85vh',
		// 	panelClass: "program-page-modal"
		// })

		// const newTab = window.open('/programs', '_blank');
		// if (newTab) {
		// 	localStorage.setItem("previewState", JSON.stringify(dataToPass));
		// }
	}

	async publishProgram() {
		let [isProgramDataValid, missingItems] = this.validateProgramFields();

		if (!isProgramDataValid) {
			// this.snackbar.open("Please fill all fields before publishing.", "OK", {
			// 	duration: 3000
			// });
			this.showValidationAlert('OOPS!', 'We can only publish when the following items are completed:', missingItems);
		} else {
			this.setMandatoryFieldsProgramData();
			this.dataLastCopy = structuredClone(this.programDataCopy);
			await this.spinner.show("blockLoader");
			await this.programBuilderMainService.addPrograms(this.programDataCopy.id, this.programDataCopy);
			await this.programBuilderMainService.publishProgram(this.programDataCopy.id, this.programDataCopy);
			await this.spinner.hide("blockLoader");

			// Capture PostHog event when program is successfully published
			const userEmail = localStorage.getItem('username');
			const role = localStorage.getItem('roleId');

			this.postHogService.capture('Publish program', {
				'User email': userEmail,
				'device_type': 'Web',
				'role': role,
				'program name': this.programDataCopy.name
			});

			this.snackbar.open("Program published to library.", "OK", {
				duration: 3000
			});
		}
	}

	courseTimeEventCapture(event: any) {
		this.autoSaved = false;
		let time = this.programDataCopy.courseTime.replace(/\D/g, ''); // Remove any non-digit characters

		time = time.slice(0, 4);

		if (time.length > 2) {
			this.programDataCopy.courseTime = time.slice(0, 2) + ":" + time.slice(2);
		} else {
			this.programDataCopy.courseTime = time;
		}
	}

	showValidationAlert(title: string, subTitle: string, fields: any) {
		const alertDialogRef = this.dialog.open(ValidationAlertComponent, {
			data: { title, subTitle, fields },
			panelClass: "validation-alert-class"
		});
	}

	changeDifficultyLevel() {
		this.autoSaved = false;
	}

	changeDisplayInCategories() {
		this.autoSaved = false;
	}

	ngOnDestroy() {
		if (this.checkChangesInterval) {
			clearInterval(this.checkChangesInterval);
		}
	}
}
